<template lang="pug">
b-modal#addDomainAppLink(
  ref="addDomainAppLink"
  :title="getLabel()"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown"
)
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    b-form-group(:label="$t('ui.domain_name')" disabled).mb-0
      DebounceInput(
        size="sm"
        ref="domain_name"
        required
        type="text"
        v-model="domain_name"
        disabled
      )
    b-form-group(:label="getAppLinkLabel()").mb-0
      DebounceInput(
        size="sm"
        ref="android_app_link"
        required
        type="text"
        :dirty="$v.app_link.$dirty"
        :error="$v.app_link.$error"
        v-model.trim.lazy="$v.app_link.$model"
        :disabled="loading"
      )
      small.form-text.text-muted {{ $t('message.info_app_link') }}
      ValidateResult(:value="$v.app_link" :name="getAppLinkLabel()")
  div(slot="modal-cancel")
    SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, requiredIf} from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  props: {
    item: {
      type: Object
    },
    appType: {
      type: String
    }
  },
  data() {
    return {
      feedback: {
        success: true,
        status: ""
      },
      domain_id: "",
      domain_name: "",
      app_link: "",
      app_type: "ANDROID",
      loading: false,
    };
  },
  computed: {
    operatorID() {
      return this.$store.getters.selectedOperatorID
    }
  },
  validations: {
    app_link: {
      required: requiredIf(function () {
        return this.app_type == "ANDROID";
      }),
    }
  },
  methods: {
    getLabel() {
      return this.$t('ui.add_' + this.app_type.toLowerCase() + '_app_link')
    },
    getAppLinkLabel() {
      return this.$t('ui.' + this.app_type.toLowerCase()  + '_app_link')
    },
    done: function(evt) {
      evt.preventDefault();
      this.$v.$touch();
      if (this.$v.$invalid) return

      this.submit();
    },
    submit: function() {
      let url = config.domainAppLinkAddUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        domain_id: this.domain_id,
        app_type: this.appType,
        app_link: this.app_link,
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.$emit("clicked");
                this.$refs.addDomainAppLink.hide();
              } else {
                this.$helpers.handleFeedback(this.feedback.status);
                this.$emit("failed", "add_domain_app_link", this.feedback.status);
                this.$refs.addDomainAppLink.hide();
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function() {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
      this.app_link = ""
    },
    shown: function() {
      this.$v.$reset();
      this.domain_id = this.item.domain_id;
      this.domain_name = this.item.domain_name;
      this.app_type = this.appType
    }
  },
};
</script>
